import React, { useState, useEffect } from 'react';
import { format, addMonths, addWeeks, addYears } from 'date-fns';
import { Button } from "react-bootstrap";
import ProgressBar from './ProgressBar';
import ToPeso from './ToPeso';
import "./css/ApplicantProcessedLoans.scss";

// Function to round up to the nearest cent if the second decimal place is not zero
const roundUp = (amount) => {
  const amountString = amount.toFixed(2);
  const secondDecimalPlace = amountString.charAt(amountString.length - 1);

  if (secondDecimalPlace !== '0') {
    return parseFloat((amount + 0.01).toFixed(2));
  }

  return amount;
};

const calculateDueDates = (startDate, interval, term, amount, interest) => {
  const dueDates = [];
  const principalAmount = amount / term;
  const interestAmountInitial = (amount * interest) / 100;
  const interestAmountMinusAdvance = (((amount * interest) / 100) * term) - interestAmountInitial;
  const interestAmount = interestAmountMinusAdvance / term;
  
  let currentDate = new Date(startDate);

  for (let i = 0; i < term; i++) {
    switch (interval.toLowerCase()) {
      case 'monthly':
        currentDate = addMonths(currentDate, 1);
        break;
      case 'bimonthly': // Twice a month, roughly every two weeks
        currentDate = addWeeks(currentDate, 2);
        break;
      case 'weekly':
        currentDate = addWeeks(currentDate, 1);
        break;
      case 'quarterly':
        currentDate = addMonths(currentDate, 3);
        break;
      case 'semiannual':
        currentDate = addMonths(currentDate, 6);
        break;
      case 'yearly':
        currentDate = addYears(currentDate, 1);
        break;
      default:
        throw new Error('Invalid interval');
    }

    dueDates.push({
      date: format(currentDate, 'MM/dd/yyyy'),
      dueAmount: roundUp(principalAmount + interestAmount)
    });
  }

  return dueDates;
};

const ApplicantProcessedLoans = ({ date, interval, term, amount, interest, paymentList, id }) => {
  const dueDates = calculateDueDates(date, interval, term, amount, interest);
  const initialIntrest = (amount * (interest/100));
  const totalRepayments = dueDates.reduce((acc, due) => acc + due.dueAmount, 0) + initialIntrest;

  const [totalPaid, setTotalPaid] = useState(0);
  const [remainingBalance, setRemainingBalance] = useState(totalRepayments);

  useEffect(() => {
    let total = 0;
    paymentList.forEach(payment => {
      total += payment.paidTotal;
    });
    setTotalPaid(total + initialIntrest);
    setRemainingBalance(totalRepayments - total - initialIntrest);

    const findElement = document.querySelectorAll('.pbar');

    findElement.forEach(div => {
      div.classList.add("payment-progress-applicant");
    });

  }, [paymentList, totalRepayments, initialIntrest]);

  return (
    <>
    <div className="processed-loans__deets">
      <ul>
        <li><i className="fa-regular fa-calendar"></i> {format(date, 'MMM dd, yyyy')}</li>
        <li><ToPeso amount={amount} /></li>
        <li><Button variant="primary" href={`/loans/${id}`}><i className="fa-solid fa-circle-info"></i> Details</Button></li>
      </ul>
    </div>
    <ProgressBar totalPayments={totalPaid.toFixed(2)} remainingBalance={remainingBalance.toFixed(2)} totalRepayments={totalRepayments.toFixed(2)} />
    </>
  );
};


export default ApplicantProcessedLoans;
